<app-diet-plan-v2 [user]="user"></app-diet-plan-v2>
